module.exports = __webpack_public_path__ + "static/media/y-wallet.8d2cc1c4.svg";